import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {solid} from "@fortawesome/fontawesome-svg-core/import.macro";

type Props = {
    text?: string;
};

export const Tooltip = ({
                            text = 'Migrated from previous Cashier version',
                        }: Props) => {
    return (
        <span className="relative inline-flex items-center group">
      <FontAwesomeIcon className="text-gray-900 dark:text-gray-500 h-3 w-3 mr-1" icon={solid('circle-info')}/>

      <span
          className="
          absolute bottom-full mb-2 hidden group-hover:block
          whitespace-nowrap rounded bg-gray-900 px-2 py-1 text-xs text-white
          shadow-lg
        "
      >
        {text}
      </span>
    </span>
    );
};
